import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import Image from '../components/image'

const IndexPage = () => (
  <Layout>
    <h1>Welcome!</h1>
    <div style={{ backgroundColor: '#ddffff', maxWidth: '300px', marginBottom: '1.45rem' }}>
      <Image />
      <p><i>A steep cliff near the wettest place in the world, Cherrapunjee.</i></p>
    </div>
    <p>We are now launching new Regional Hydroclimatological Project (RHP)
       under <a href="https://www.gewex.org">GEWEX</a> focused on Asian monsoon
       based on achievements of the <a href="http://hydro.iis.u-tokyo.ac.jp/mahasriwiki/wiki/index.html">MAHASRI</a> project (2006-2016),
       Now, we are in the status of "proposed RHP" under GHP.</p>
    <p>Project name is now under discussion.
       'Post MAHASRI' is tentative name.</p>
    <p>Our main objective is understanding of Asian land precipitation over diverse hydroclimatological conditions for better prediction, disaster reduction and sustainable development.</p>
    <p>Main focus of this project are described in following pages.</p>
    <ul>
      <li><Link to="/key-questions/">Overarching Key Questions</Link></li>
      <li><Link to="/scientific-approaches/">Scientific Approaches</Link></li>
      <li><Link to="/amy-ii/">AMY (Asian Monsoon Year)-II in 2020</Link></li>
    </ul>
    <p>Recent activities will be listed in the following links.</p>
    <ul>
      <li><Link to="/news/">News</Link></li>
      <li><Link to="/news/20181126a/">Report on GHP Panel Meeting 2018(24-26 Oct., Santiago, Chille)</Link></li>
    </ul>
  </Layout>
)

export default IndexPage
